// Constants file
// Define any global constants needed for the theme

// Currency code for money formatting
window.currencyCode = window.Shopify?.currency?.active || 'USD';

// Shopify routes (if not already defined)
window.Shopify = window.Shopify || {};
window.Shopify.routes = window.Shopify.routes || {
  root: '/',
  cart_add_url: '/cart/add',
  cart_change_url: '/cart/change',
  cart_update_url: '/cart/update',
};

